import { InvestorsApi } from 'api';
import useApiCall from 'hooks/use-api-call';
import React, { FunctionComponent, useMemo } from 'react';
import Translate from 'ui/atoms/translate';
import { Modal, makeModalForm, ModalHeader, ModalFooter, ModalContent, ModalFooterButtons } from 'ui/molecules/modal';
import { StateValues } from 'react-use-form-state';

export interface EditBankAccountFields {
  id: string;
  accountHolder?: string;
  iban?: string;
}
export interface EditBankAccountModalProps {
  onHideEditBankAccount: () => void;
  fetchInvestorDetails: () => void;
  className?: string;
  values: EditBankAccountFields;
}

const EditBankAccountForm = makeModalForm<EditBankAccountFields>();

const EditBankAccountModal: FunctionComponent<EditBankAccountModalProps> = (props) => {
  const { onHideEditBankAccount, fetchInvestorDetails, values } = props;

  const { makeAuthenticatedApi, withApi } = useApiCall();

  const investorsApi: InvestorsApi = useMemo(() => makeAuthenticatedApi(InvestorsApi), [makeAuthenticatedApi]);

  const editBankAccount = (fieldsValues: StateValues<EditBankAccountFields>) => {
    withApi(async () => {
      const patchBody = {
        id: values.id,
        patchedInvestorUpdateRequest: {
          bankAccount: {
            accountHolder: fieldsValues.accountHolder || '',
            iban: fieldsValues.iban || '',
          },
        },
      };

      await investorsApi.investorsPartialUpdate(patchBody);

      fetchInvestorDetails();
      onHideEditBankAccount();
    });
  };

  return (
    <>
      <Modal onClose={onHideEditBankAccount}>
        <EditBankAccountForm
          initial={{
            accountHolder: values.accountHolder,
            iban: values.iban,
          }}
          onSubmit={(values: StateValues<EditBankAccountFields>) => {
            return editBankAccount(values);
          }}
          i18nKey="dashboardIssuerInvestorDetails.editBankAccountForm"
        >
          <ModalHeader>
            <Translate name="dashboardIssuerInvestorDetails.editBankAccountForm.title" />
          </ModalHeader>
          <ModalContent>
            <EditBankAccountForm.Group name="accountHolder" required={true}>
              <EditBankAccountForm.Input placeholder="-" />
            </EditBankAccountForm.Group>
            <EditBankAccountForm.Group name="iban" required={true}>
              <EditBankAccountForm.Input placeholder="-" />
              {EditBankAccountForm.Validators.IBAN()}
            </EditBankAccountForm.Group>
          </ModalContent>
          <ModalFooter>
            <ModalFooterButtons
              actionButtons={[
                {
                  name: 'cancel',
                  content: <Translate name="common.cancel" />,
                  size: 'large',
                  onClick: onHideEditBankAccount,
                },
                {
                  name: 'update',
                  content: <Translate name="common.save" />,
                  variant: 'primary',
                  type: 'submit',
                  size: 'large',
                },
              ]}
            />
          </ModalFooter>
        </EditBankAccountForm>
      </Modal>
    </>
  );
};

export default EditBankAccountModal;
